import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  landingActiveStepErrorsAtom,
  LandingStepErrorsEnum,
} from "@ryde/utils-landings";

import { GeneralError } from "../../errors-template";

export const StepErrorHerzliya: FC = () => {
  const activeStepErrors = useRecoilValue(landingActiveStepErrorsAtom);
  const { type } = activeStepErrors ?? {};

  const ErrorContentMap = useMemo(() => {
    switch (type) {
      case LandingStepErrorsEnum.GeneralError:
        return <GeneralError />;
      default:
        return null;
    }
  }, [type]);

  return (
    <>
      <div className="landing-top-illustration" aria-hidden="true"></div>
      {ErrorContentMap}

      <div className="landing-bottom-illustration" aria-hidden="true"></div>
      <div className="landing-container-footer">
        <div className="landing-container-footer-logo" aria-hidden="true"></div>
      </div>
    </>
  );
};
